/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    // 平台管理员权限
    isPlatformAdmin: currentUser && currentUser.role === 1,
    // 企业管理员权限
    isEnterpriseAdmin: currentUser && currentUser.role === 2,
    // 任何管理员权限（平台或企业）
    canAdmin: currentUser && (currentUser.role === 1 || currentUser.role === 2),
  };
}
